import api from '../api'
import find from 'lodash/find'
import {fetchUser} from './user'
import {fetchPollsForQuestion} from './polls'
import {fetchControl} from './control'
import {fetchSections} from './sections'
import {fetchService} from './service'
import {fetchMeta} from './meta'
import {syncClock} from './syncClock'
import {fetchGeoInfo} from './geoInfo'
import {fetchARepoAndPermissions,fetchRepos} from './repos'
import {fetchReviewsForUser} from './reviews'
import {fetchLocksForRepo} from './locks'
import store from '../store'
 import {fetchSubmissions} from './submissions'


export function loadQuestionEditorData(questionId,userId) {
	if(questionId !=='newquestion'){
		return (dispatch) => {
			api.fetch(`/questions/${questionId}`)
				.then((response) => {
					dispatch({ type: 'FETCH_A_QUESTION_SUCCESS', response })
					if(response.repo){
						let promises=[]
						promises.push(dispatch(fetchARepoAndPermissions(response.repo)))
						promises.push(dispatch(fetchLocksForRepo(response.repo)))

						Promise.all(promises).then(function () {
							const state = store.getState()
							const parentRepo = find(state.repos, {'id':response.repo})
							if(parentRepo && parentRepo.shared){
								let lockState='unlocked'
								const repoLocks=state.locks[response.repo]
								const lock = find(repoLocks, function(lock) {
    							return lock.item === questionId
								})
						
								if(lock && state.user){
									if(lock.user !== state.user.id){
										lockState='lockedByAnotherUser'
									}
								}
								window.analytics.track('Open Shared Item',{
									itemType:'question',
									lockState:lockState
								})	

							}

						})
					}

					dispatch(fetchRepos())
					dispatch(fetchReviewsForUser())
					
					dispatch(fetchService())
					dispatch(fetchControl())
					dispatch(fetchPollsForQuestion(questionId))
					dispatch(fetchSections())
					dispatch(fetchUser(userId))
					dispatch(fetchMeta())
					dispatch(fetchGeoInfo())
					dispatch(fetchSubmissions())

					setTimeout(function() { //Start the timer
						dispatch(syncClock())
					},	5000)
					//dispatch(fetchMobileInfo())
				})
				.catch(err => {
	    		 })

			}
	}else{
		return (dispatch) => {
			api.fetch('/control')
				.then((response) => {
					dispatch({ type: 'FETCH_CONTROL_SUCCESS', response })
					dispatch(fetchService())
					dispatch(fetchRepos())
					dispatch(fetchReviewsForUser())
					dispatch(fetchControl())
					dispatch(fetchSections())
					dispatch(fetchUser(userId))
					dispatch(fetchMeta())
					dispatch(fetchGeoInfo())
					dispatch(fetchSubmissions())
					setTimeout(function() { //Start the timer
						dispatch(syncClock())
					},	5000)
					//dispatch(fetchMobileInfo())
				})
				.catch(err => {
	    		 })
			}
	}
}

